import * as React from 'react'

export const Home = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.8 7.652 10.067 2l7.266 5.652v8.881a1.615 1.615 0 0 1-1.615 1.615H4.415A1.615 1.615 0 0 1 2.8 16.533V7.652Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.646 18.148v-8.074h4.844v8.074"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
